
import { styled } from '@mui/material/styles';
import MuiTableHead from '@mui/material/TableHead';
import MuiTableRow from '@mui/material/TableRow';

export const EDStickyTableHeader: React.FC<React.PropsWithChildren> = props => (
  <MuiTableHead>
    <StyledTableRow>{props.children}</StyledTableRow>
  </MuiTableHead>
);

export const StyledTableRow = styled(MuiTableRow, {
  name: 'StickyTableHeader',
})(() => ({
  padding: 0,
  height: 'var(--header-height)',
  boxSizing: 'border-box',
  position: 'var(--header-position)' as React.CSSProperties['position'],
  top: 0,
  zIndex: 8,
}));
